import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYouTube = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.6466 3.71569C15.5549 3.38408 15.3758 3.08175 15.1274 2.83883C14.879 2.5959 14.5698 2.42085 14.2306 2.3311C12.989 2 7.99189 2 7.99189 2C7.99189 2 2.99451 2.01002 1.75289 2.34112C1.41373 2.43088 1.10454 2.60594 0.856102 2.84888C0.607665 3.09181 0.428651 3.39415 0.336887 3.72578C-0.0386755 5.88288 -0.184363 9.1698 0.347199 11.2406C0.438973 11.5722 0.617991 11.8746 0.866427 12.1175C1.11486 12.3604 1.42405 12.5355 1.7632 12.6252C3.00482 12.9563 8.00208 12.9563 8.00208 12.9563C8.00208 12.9563 12.9993 12.9563 14.2408 12.6252C14.58 12.5355 14.8892 12.3604 15.1376 12.1175C15.3861 11.8746 15.5651 11.5722 15.6569 11.2406C16.053 9.08046 16.1751 5.79555 15.6466 3.71569Z",
		fill: "#FF0000"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.40137 9.82444L10.5469 7.47667L6.40137 5.12891V9.82444Z",
		fill: "white"
	})]
});
export default SvgYouTube;
